import React, { useRef, useState, useImperativeHandle } from 'react';
import useGoogleMaps from 'plugin/googleMaps';
import Form from './form';
import Button from './button';

const fields = [
    { dataIndex: 'address', title: '地址', span: 2 },
    { dataIndex: 'lng', title: '經度', type: 'Float' },
    { dataIndex: 'lat', title: '緯度', type: 'Float' }
];

const EntryForm = React.forwardRef((props, ref) => {
    const { onClickClear, onClickLocate } = props;
    const googleMaps = useGoogleMaps();

    const formRef = useRef();
    const [formValues, setFormValues] = useState({});
    const onChangeForm = (key, value) => {
        setFormValues((prev) => ({ ...prev, [key]: value }));
    };
    const onBlur = (key) => {
        if (key === 'address' && googleMaps.geocode) {
            googleMaps.geocode({ address: formValues.address }).then(({ results }) => {
                const newLatLng = results[0].geometry.location.toJSON();
                setFormValues((prev) => ({ ...prev, ...newLatLng }));
                ref.current.setValues(newLatLng);
            }).catch((e) => e);
        }
    };

    useImperativeHandle(ref, () => ({
        setValues: (values) => {
            setFormValues((prev) => ({ ...prev, ...values }));
            formRef.current.setValues(values);
        }
    }));

    return (
        <>
            <Form
                ref={formRef}
                title={(
                    <div className="font-normal text-sm text-gray-dark01">
                        輸入入口經緯度、地址或右鍵點擊地圖產生車輛入口
                    </div>
                )}
                grid={2}
                fields={fields}
                onChange={onChangeForm}
                onBlur={onBlur}
            />
            <div className="flex justify-center gap-2 mb-5">
                <Button className="w-1/3" type="" onClick={() => onClickClear?.()}>清除入口</Button>
                <Button className="w-1/3" onClick={() => onClickLocate?.(formValues)}>定位</Button>
            </div>
        </>
    );
});

export default EntryForm;
